import type { EnumValue } from '../utils/utility.types';

export const AccessGroupType = {
    Host: 'HOST',
    Network: 'NETWORK',
    UserGroup: 'USER_GROUP',
    HostService: 'HOST_SERVICE',
    NetworkService: 'NETWORK_SERVICE',
    PublishedSevice: 'PUBLISHED_SERVICE',
} as const;

export const AccessInternetType = {
    Local: 'LOCAL',
    Global: 'GLOBAL_INTERNET',
    Blocked: 'BLOCKED',

    friendlyString(entry: string): string {
        const map = {
            [this.Local]: 'Split Tunnel On',
            [this.Global]: 'Split Tunnel Off',
            [this.Blocked]: 'Restricted Internet',
        };

        return map[entry as unknown as keyof typeof map] ?? entry;
    },
} as const;

export const AccessInternetTypeOptions = [
    AccessInternetType.Local,
    AccessInternetType.Global,
    AccessInternetType.Blocked,
].map(t => ({ name: AccessInternetType.friendlyString(t), value: t }));

export type AccessGroupTypeValue = EnumValue<typeof AccessGroupType>;
export type AccessInternetTypeValue = EnumValue<typeof AccessInternetType>;
